// ES6 arrow function causes an issue that the variable
// passed in the template inaccessible
// Please refer to this issue: https://github.com/pcardune/handlebars-loader/issues/180

export default function(conditional, options) {
  if (conditional === options.hash.equals) {
    return options.fn(this);
  } else {
    return options.inverse(this);
  }
};
